import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=52d3c2a0&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=52d3c2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3c2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d3c2a0')) {
      api.createRecord('52d3c2a0', component.options)
    } else {
      api.reload('52d3c2a0', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=52d3c2a0&scoped=true&", function () {
      api.rerender('52d3c2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/components/Table.vue"
export default component.exports